module.exports = __webpack_public_path__ + "img/nfc-pen.275f850d.svg";